__turbopack_context__.v({
  "blogContainer": "BlogSection-module__gDoxeq__blogContainer",
  "blogElement": "BlogSection-module__gDoxeq__blogElement",
  "root": "BlogSection-module__gDoxeq__root",
  "subtitle": "BlogSection-module__gDoxeq__subtitle",
  "textContent": "BlogSection-module__gDoxeq__textContent",
});
